export enum MenuSelectionHubEvents {
  ORDERS_UPDATED = "MenuSelectionOrderUpdated",
  ORDERS_UPDATE_FAILED = "UpdateMenuSelectionOrderFailed",
}
